import React, {useState} from 'react'
import { InlineMath } from 'react-katex'
import Benar from '../2/img/benar.svg'
import Salah from '../2/img/salah.svg'
import Warning from '../2/img/warning.svg'

const Marimencoba = (ukuranH, ukuranP) => {
  
 
    const [styleno1, setStyleno1] = useState({width:'50px'})
    const [styleno2, setStyleno2] = useState({width:'50px'})
    const [styleno3, setStyleno3] = useState({width:'50px'})
    const [styleno4, setStyleno4] = useState({width:'50px'})
    const [styleno5, setStyleno5] = useState({width:'50px'})
    const [styleno6, setStyleno6] = useState({width:'50px'})
    const [styleno7, setStyleno7] = useState({width:'50px'})
    const [styleno8, setStyleno8] = useState({width:'50px'})
    const [styleno9, setStyleno9] = useState({width:'50px'})
    const [styleno10, setStyleno10] = useState({width:'50px'})


    const handleNo1 = (no1) =>{
       const jwb = no1.target.value;
       if(jwb.toUpperCase() === "S"){
           setStyleno1({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       }  
        else if(jwb===""){
            setStyleno1({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
        } else{            
            setStyleno1({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
        }       
    }
    const handleNo2 = (no2) =>{
       const jwb = no2.target.value;
        if(jwb.toUpperCase() === "S"){
           setStyleno2({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       }  
        else if(jwb===""){
            setStyleno2({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
        } else{            
            setStyleno2({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
        }       
    
    }
    const handleNo3 = (no3) =>{
       const jwb = no3.target.value;
        jwb.toUpperCase() === "B" 
        ? setStyleno3({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
        :
        jwb.toUpperCase() === ""  
        ? setStyleno3({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
        : setStyleno3({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
        
    }
    const handleNo4 = (no4) =>{
       const jwb = no4.target.value;
       jwb.toUpperCase() === "B" 
        ? setStyleno4({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
        :
        jwb.toUpperCase() === ""  
        ? setStyleno4({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
        : setStyleno4({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})   
    }
    const handleNo5 = (no5) =>{
       const jwb = no5.target.value;
       jwb.toUpperCase() === "S" 
       ? setStyleno5({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       :
       jwb.toUpperCase() === ""  
       ? setStyleno5({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
       : setStyleno5({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
    }
    const handleNo6 = (no6) =>{
       const jwb = no6.target.value;
       jwb.toUpperCase() === "B" 
       ? setStyleno6({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       :
       jwb.toUpperCase() === ""  
       ? setStyleno6({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
       : setStyleno6({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
    
    }
    const handleNo7 = (no7) =>{
       const jwb = no7.target.value;
       jwb.toUpperCase() === "S" 
       ? setStyleno7({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       :
       jwb.toUpperCase() === ""  
       ? setStyleno7({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
       : setStyleno7({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
    
    }
    const handleNo8 = (no8) =>{
       const jwb = no8.target.value;
       jwb.toUpperCase() === "S" 
       ? setStyleno8({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       :
       jwb.toUpperCase() === ""  
       ? setStyleno8({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
       : setStyleno8({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
    
    }
    const handleNo9 = (no9) =>{
       const jwb = no9.target.value;
       jwb.toUpperCase() === "B" 
       ? setStyleno9({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       :
       jwb.toUpperCase() === ""  
       ? setStyleno9({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
       : setStyleno9({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
    
    }
    const handleNo10 = (no10) =>{
       const jwb = no10.target.value;
       jwb.toUpperCase() === "S" 
       ? setStyleno10({width:'50px',background:'#4dff4d ',borderRadius:'20px', backgroundImage: `url(${Benar})`, backgroundRepeat  : 'no-repeat', backgroundPosition: 'center'})
       :
       jwb.toUpperCase() === ""  
       ? setStyleno10({width:'50px',background:'yellow',borderRadius:'20px', backgroundImage: `url(${Warning})`, backgroundRepeat: 'repeat-y', backgroundPosition: 'center center',position:'relative'})
       : setStyleno10({width:'50px',background:' #ff4d4d',borderRadius:'20px', backgroundImage: `url(${Salah})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center'})
    
    }
    return (
        <div className="container-fluid mt-3 mb-2">

        <div style={{margin:'auto',width:'100%',position:'relative'}} >
               <div style={{margin:'auto',textAlign:'justify',width:'90%'}}>
               <p className="text-center" style={{fontSize:`${ukuranH}px`, color:'black'}}>Perhatikan pernyataan dibawah ini dengan teliti! berikan jawaban <strong>“S”</strong> untuk jawaban salah dan <strong> “B” </strong> untuk jawaban benar !</p>
               </div>
             

                <table className="text-center" style={{margin:'auto',width:'100%',textAlign:'center',color:'black', fontSize:`${ukuranP}px`}}>
                  
                        <tr>
                        <div className="row ">
                        <div className="col-lg-7 offset-lg-1 offset-lg-1 col-md-6 col-sm-12 ">
                            <td>1)</td>
                            <td><InlineMath math=" 3x ≥ y - 8 - x^2" /><p> merupakan pertidaksamaan linear dua variabel.</p></td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <td>
                                <input type="text" onChange={handleNo1} style={{width:'50px'}} maxLength={1} />
                            </td>
                            <td style={styleno1}></td>
                        </div>
                        </div>    
                        </tr>
                  
                    <tr> <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>2)</td>
                        <td><InlineMath math=" \sqrt{\smash[b]{y}} - 3x ≤ 10\ " /> merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo2} style={{width:'50px'}} maxLength={1}  /></td>
                        <td style={styleno2}></td>
                        </div>
                        </div>  
                    </tr>
                    <tr>
                    <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>3)</td>
                        <td><InlineMath math="4x - 2y ≤ 10 " /> merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td> <input type="text" onChange={handleNo3} style={{width:'50px'}} maxLength={1} /></td>
                        <td style={styleno3}></td>
                        </div>
                        </div>  
                    </tr>
                    <tr>
                    <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>4)</td>
                        <td><InlineMath math="2x + 6y ≤ 24" /> merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo4} style={{width:'50px'}} maxLength={1} /></td>
                        <td style={styleno4}></td>
                        </div>
                        </div> 
                    </tr>
                    <tr>
                    <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>5)</td>
                        <td><InlineMath math="\ 6x + 2y ≤ 3 , z - 3x + y ≥ 0" /> merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo5} style={{width:'50px'}} maxLength={1}/></td>
                        <td style={styleno5}></td>
                        </div>
                        </div>
                    </tr>
                    <tr>
                    <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>6)</td>
                        <td><InlineMath math="\ 7 < 3y + 2x \ " /> merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo6}  style={{width:'50px'}} maxLength={1}/></td>
                        <td style={styleno6}></td>
                        </div>
                        </div>
                    </tr>
                    <tr>
                    <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>7)</td>
                        <td><InlineMath math=" 2x + y  ≥ 12\  " /> bukan merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo7} style={{width:'50px'}} maxLength={1}  /></td>
                        <td style={styleno7}></td>    
                        </div>            
                        </div>            
                  </tr>
               
                    <tr>
                    <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>8)</td>
                        <td><InlineMath math="2x + 6y = 10" />  merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo8} style={{width:'50px'}} maxLength={1} /></td>                     
                        <td style={styleno8}></td>
                        </div>
                        </div>
                    </tr>
                    <tr>
                    <div className="row mt-2">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>9)</td>
                        <td><InlineMath math="x + 5y ≤ 15 " />  merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo9} style={{width:'50px'}} maxLength={1}/></td>
                        <td style={styleno9}></td>
                        </div>
                        </div>
                    </tr>
                    <tr>
                    <div className="row mt-2 mb-1">
                        <div className="col-lg-7 offset-lg-1 col-md-6 col-sm-12 ">
                        <td>10)</td>
                        <td><InlineMath math=" 2x + 2y = 6\ " /> bukan merupakan pertidaksamaan linear dua variabel.</td>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                        <td><input type="text" onChange={handleNo10} style={{width:'50px'}} maxLength={1} /></td>
                        <td style={styleno10}></td> 
                        </div>
                        </div>
                    </tr>
                </table>              
            </div>
            <div className="text-center mt-5">Apabila telah menyelesaiakan semua, maka klik tombol X pada pojok kanan kiri layar. Selanjutnya klik <b>"Mari Mencoba2"</b></div>
        </div>
    )
}

export default Marimencoba
